<template>
  <div class="t-work-area__row">
    <div class="t-work-area__column_big t-settings">
      <div v-if="blackList.items.length > 0" class="t-work-area__cell">
        <div class="t-black-list">
          <div class="t-black-list__item t-black-list-item" v-for="item in blackList.items" :key="'black-list_' + item.id">
            <p class="t-black-list-item__name">{{ item.name }}</p>
            <router-link :to="{name: 'user', params: {url: item.url}}" class="t-black-list-item__link">{{ pageText.profile }}</router-link>
            <button class="t-btn t-btn_border" @click.prevent="Delete(item.id)"><span>{{ pageText.delBtn }}</span></button>
          </div>
        </div>
      </div>
      <p v-else>{{ pageText.msgNone }}</p>

      <cmp-banner></cmp-banner>
      <cmp-promo-courses 
          :text="{title:pageText.title_1}"
          :items="recommendations.courses">
      </cmp-promo-courses>
    </div>
    <div class="t-work-area__column_small">
      <cmp-promo-teachers 
          :text="{title:pageText.title_2, promoBtn: pageText.promoBtn}"
          :items="recommendations.teachers">
      </cmp-promo-teachers>
    </div>
  </div>
</template>

<script>
    let localeText = {
        url: process.env.NODE_ENV !== 'production' ? 'staticText/blackListPage.json' : 'staticText',
        main: {
            addBtn: "В черный список",
            profile: "Профиль",
            delBtn: "Удалить",
            code: "Активировать код",
            title_1: "Рекомендуемый курс",
            title_2: "Рекомендуемый учитель",
            msgSuccess: "Пользователь удален из черного списка",
            msgNone: "В вашем черном списке никого нет",
            promoBtn: 'Заказать рекламу'
        }
    };

    import {store} from '../../store'

    // import Course from '../../vue_components/Course.vue'
    // import Teacher from '../../vue_components/Teacher.vue'    
    import PromoTeachers from '../../vue_components/PromoTeachers.vue'
    import PromoCourses from '../../vue_components/PromoCourses.vue'

    import Banner from '../../vue_components/Banner.vue'

    import {mapGetters,mapActions} from 'vuex'

    export default {
        data(){
            return {
                pageText: {}
            }
        },
        components: {
            // 'cmp-course': Course,
            // 'cmp-teacher': Teacher,
            'cmp-promo-teachers': PromoTeachers,
            'cmp-promo-courses': PromoCourses,
            'cmp-banner': Banner,
        },
        computed: {
            ...mapGetters('recommendations', ['recommendations']),
            ...mapGetters('profile', ['blackList'])
        },
        methods: {
            ...mapActions(['UpdatePreloadState']),
            ...mapActions('profile', ['LoadBlackList']),
            ...mapActions('msg', ['showMsg']),
            Load(pageText){
                this.pageText = pageText;

                // setTimeout(() => {
                //     this.UpdatePreloadState(false);
                // }, 500)
            },
            Delete(id){
                this.$http.delete('profile/blackList/' + id)
                    .then(response => {
                        if(response.body.success){
                            this.LoadBlackList();
                            this.showMsg(this.pageText.msgSuccess);
                        } else{
                            let error_text = [];

                            for(let key in response.body.errors){
                                error_text.push(response.body.errors[key].join(', '));
                            }

                            this.showMsg(error_text.join(', '));
                        }
                    }, response => {
                        this.showMsg('Упс, что-то пошло не так, попробуйте позже');
                        this.login_edit = false;
                        this.login.value = this.user.login
                    });
            }
        },
        beforeRouteLeave (to, from, next) {
            // this.UpdatePreloadState(true);
            next();
        },
        beforeRouteEnter (to, from, next) {
            let count = 0;
            let pageText = {};

            store.dispatch('staticText/LoadPageText', localeText).then((data) => {
                pageText = data;

                count++;
                RunNext();
            });
            store.dispatch('recommendations/LoadRecommendations').then(() => {
                count++;
                RunNext();
            });
            store.dispatch('profile/LoadBlackList').then(() => {count++;RunNext();});
            let RunNext = () => {
                if(count > 2)
                    next(vm => vm.Load(pageText))
            }
        }
    }
</script>

<style lang="sass">
.t-black-list-form
  display: flex
  align-items: center
  align-items: center
  .t-btn
    margin-left: 24px
  input
    max-width: 560px

.t-black-list
  width: 100%
  &__item
    width: 100%
    padding: 16px 0
    &:not(:last-child)
      border-bottom: 1px solid $input
.t-black-list-item
  display: flex
  align-items: center
  &__name
    font-weight: bold
    margin-right: 16px
  &__link
    color: $blue
    font-weight: bold
    transition: color .2s
    @media (min-width: 770px)
      &:hover
        color: $turquoise
  .t-btn
    margin-left: auto
    line-height: 22px
    font-size: 14px
    font-weight: normal
</style>


// WEBPACK FOOTER //
// src/vue_pages/Profile/BlackList.vue